import type { DelegatedSubAdminCheckInput } from "./rbacExternalAdmin";
import { roleRenamer } from "./RoleRenamer";
import {
  DELEGATED_SUB_ADMIN_LABEL,
  isDelegatedSubAdmin,
} from "./rbacExternalAdmin";

/** Role label for masjid/org assigned user rows (entity tables & details). */
export function getAssignedUserRoleLabel(
  user: DelegatedSubAdminCheckInput | null | undefined
): string {
  if (!user?.role) {
    return "";
  }
  if (isDelegatedSubAdmin(user)) {
    return DELEGATED_SUB_ADMIN_LABEL;
  }
  return roleRenamer(user.role);
}

/**
 * Custom role display based on ownership type
 * @param role - The admin role (e.g., 'subadmin', 'musaliadmin')
 * @param ownershipType - The ownership type (e.g., 'MASJID', 'ORGANIZATION', 'INDIVIDUAL')
 * @returns The formatted role display name
 */
export const getDisplayRole = (role: string, ownershipType: string): string => {
  if (ownershipType === "ORGANIZATION") {
    return role === "subadmin" ? "Admin" : "Admin";
  } else if (ownershipType === "INDIVIDUAL") {
    return role === "subadmin" ? "Admin" : "Admin";
  } else {
    // For MASJID type, use the original roleRenamer
    return roleRenamer(role);
  }
};
